import { render, staticRenderFns } from "./TaskUserList.vue?vue&type=template&id=535c19e2&scoped=true&"
import script from "./TaskUserList.vue?vue&type=script&lang=ts&"
export * from "./TaskUserList.vue?vue&type=script&lang=ts&"
import style0 from "./TaskUserList.vue?vue&type=style&index=0&id=535c19e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c19e2",
  null
  
)

/* custom blocks */
import block0 from "./TaskUserList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports